import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="min-h-screen bg-white/70 backdrop-blur-md shadow-lg flex items-center section-padding pt-32">
      <div className="container-max">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Hi, I'm <span className="text-primary-600">Sirine</span>
            </h1>
            <h2 className="text-2xl md:text-3xl text-gray-700 mb-6">
              Data Scientist & Applied Mathematics Student
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Passionate about transforming data into insights and building intelligent systems 
              that solve real-world problems. Experienced in deep learning, medical image analysis, 
              and statistical modeling.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="#contact" className="btn-primary text-center">
                <i className="fas fa-envelope mr-2"></i>
                Get In Touch
              </a>
              <a 
                href="/sirine_mimouni_lsd.pdf" 
                download
                className="bg-white border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 text-center"
              >
                <i className="fas fa-download mr-2"></i>
                Download CV
              </a>
            </div>
            <div className="flex space-x-6 mt-8">
              <a 
                href="https://www.linkedin.com/in/mimouni-sirine/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-2xl text-gray-600 hover:text-primary-600 transition-colors duration-300"
              >
                <i className="fab fa-linkedin"></i>
              </a>
              <a 
                href="mailto:mimounisirine348@email.com"
                className="text-2xl text-gray-600 hover:text-primary-600 transition-colors duration-300"
              >
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>
          
          <div className="animate-slide-up">
            <div className="relative">
              <div className="w-80 h-80 mx-auto bg-gradient-to-br from-primary-400 to-primary-600 rounded-full shadow-2xl flex items-center justify-center overflow-hidden">
                <img 
                  src="/sirine.jpg" 
                  alt="Sirine" 
                  className="object-cover w-full h-full rounded-full" 
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-white rounded-full shadow-lg flex items-center justify-center">
                <i className="fas fa-chart-line text-2xl text-primary-600"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
